export default {
  页面曝光: {
    f_module: '页面曝光',
    f_resource: 'huoshao',
    f_type: 0
  },
  头图: {
    mod: {
      f_module: '头图',
      f_resource: '头图',
      f_type: 1
    },
    看视频: {
      f_module: '头图',
      f_resource: '看视频',
      f_type: 4
    },
    头像: {
      f_module: '头图',
      f_resource: '头像',
      f_type: 4
    },
    规则: {
      f_module: '头图',
      f_resource: '规则',
      f_type: 4
    }
  },
  购买模块: {
    mod: {
      f_module: '购买模块',
      f_resource: '购买模块',
      f_type: 1
    },
    预约: {
      f_module: '购买模块',
      f_resource: '预约',
      f_type: 4
    },
    已预约: {
      f_module: '购买模块',
      f_resource: '已预约',
      f_type: 4
    },
    购买电子票: {
      f_module: '购买模块',
      f_resource: '购买电子票',
      f_type: 4
    },
    分享票根: {
      f_module: '购买模块',
      f_resource: '分享票根',
      f_type: 4
    },
    会员开通: {
      f_module: '购买模块',
      f_resource: '会员开通',
      f_type: 4
    }
  },
  送好友: {
    mod: {
      f_module: '送好友',
      f_resource: '送好友',
      f_type: 1
    },
    赠送好友: function _(index) {
      return {
        f_module: '送好友',
        f_resource: "\u8D60\u9001\u597D\u53CB".concat(index),
        f_type: 4
      };
    },
    查看领取详情: function _(index) {
      return {
        f_module: '送好友',
        f_resource: "\u67E5\u770B\u9886\u53D6\u8BE6\u60C5".concat(index),
        f_type: 4
      };
    }
  },
  购买榜单: {
    mod: {
      f_module: '购买榜单',
      f_resource: '购买榜单',
      f_type: 1
    },
    灯牌规则: {
      f_module: '购买榜单',
      f_resource: '灯牌规则',
      f_type: 4
    },
    灯牌: {
      f_module: '购买榜单',
      f_resource: '灯牌',
      f_type: 4
    },
    编辑灯牌: {
      f_module: '购买榜单',
      f_resource: '编辑灯牌',
      f_type: 4
    },
    榜单规则: {
      f_module: '购买榜单',
      f_resource: '榜单规则',
      f_type: 4
    },
    分享票根: {
      f_module: '购买榜单',
      f_resource: '分享票根',
      f_type: 4
    }
  },
  免费活动: {
    mod: {
      f_module: '免费活动',
      f_resource: '免费活动',
      f_type: 1
    },
    免费活动: function _(index) {
      return {
        f_module: '免费活动',
        f_resource: "\u514D\u8D39\u6D3B\u52A8".concat(index),
        f_type: 4
      };
    }
  },
  道具玩法介绍: {
    mod: {
      f_module: '道具玩法介绍',
      f_resource: '道具玩法介绍',
      f_type: 1
    },
    查看道具: {
      f_module: '道具玩法介绍',
      f_resource: '查看道具',
      f_type: 4
    },
    立即购买电子票: {
      f_module: '道具玩法介绍',
      f_resource: '立即购买电子票',
      f_type: 4
    }
  },
  PCG活动: {
    mod: {
      f_module: 'PCG活动',
      f_resource: 'PCG活动',
      f_type: 1
    },
    活动: function _(index) {
      return {
        f_module: 'PCG活动',
        f_resource: "PCG\u6D3B\u52A8".concat(index),
        f_type: 4
      };
    }
  },
  banner: {
    mod: {
      f_module: 'banner',
      f_resource: 'banner',
      f_type: 1
    },
    banner: function banner(index) {
      return {
        f_module: 'banner',
        f_resource: "banner".concat(index),
        f_type: 4
      };
    }
  },
  开通弹框: {
    mod: {
      f_module: '开通弹框',
      f_resource: '开通弹框',
      f_type: 1
    },
    原价购买: {
      f_module: '开通弹框',
      f_resource: '原价购买',
      f_type: 4
    },
    开通会员: {
      f_module: '开通弹框',
      f_resource: '开通会员',
      f_type: 4
    }
  },
  购买弹框: {
    mod: {
      f_module: '购买弹框',
      f_resource: '购买弹框',
      f_type: 1
    },
    勾选自己: {
      f_module: '购买弹框',
      f_resource: '勾选自己',
      f_type: 4
    },
    勾选买赠: {
      f_module: '购买弹框',
      f_resource: '勾选买赠',
      f_type: 4
    },
    增加份数: {
      f_module: '购买弹框',
      f_resource: '增加份数',
      f_type: 4
    },
    减少份数: {
      f_module: '购买弹框',
      f_resource: '减少份数',
      f_type: 4
    },
    输入份数: {
      f_module: '购买弹框',
      f_resource: '输入份数',
      f_type: 4
    },
    开通会员: {
      f_module: '购买弹框',
      f_resource: '开通会员',
      f_type: 4
    }
  },
  分享票根: {
    mod: {
      f_module: '分享票根',
      f_resource: '分享票根',
      f_type: 1
    },
    分享图: {
      f_module: '分享票根',
      f_resource: '分享图',
      f_type: 4
    },
    换一换: {
      f_module: '分享票根',
      f_resource: '换一换',
      f_type: 4
    },
    关闭: {
      f_module: '分享票根',
      f_resource: '关闭',
      f_type: 4
    }
  },
  赠送好友: {
    mod: {
      f_module: '赠送好友',
      f_resource: '赠送好友',
      f_type: 1
    },
    分享图: {
      f_module: '赠送好友',
      f_resource: '分享图',
      f_type: 4
    },
    换一换: {
      f_module: '赠送好友',
      f_resource: '换一换',
      f_type: 4
    },
    关闭: {
      f_module: '赠送好友',
      f_resource: '关闭',
      f_type: 4
    }
  },
  领取弹框: {
    mod: {
      f_module: '领取弹框',
      f_resource: '领取弹框',
      f_type: 1
    },
    立即登录: {
      f_module: '领取弹框',
      f_resource: '立即登录',
      f_type: 4
    },
    领取: {
      f_module: '领取弹框',
      f_resource: '领取',
      f_type: 4
    },
    自己领取: {
      f_module: '领取弹框',
      f_resource: '自己领取',
      f_type: 4
    },
    查看活动: {
      f_module: '领取弹框',
      f_resource: '查看活动',
      f_type: 4
    }
  },
  直播提醒弹框: {
    mod: {
      f_module: '直播提醒弹框',
      f_resource: '直播提醒弹框',
      f_type: 1
    },
    看直播: {
      f_module: '直播提醒弹框',
      f_resource: '看直播',
      f_type: 4
    },
    留在活动: {
      f_module: '直播提醒弹框',
      f_resource: '留在活动',
      f_type: 4
    }
  },
  编辑灯牌: {
    mod: {
      f_module: '编辑灯牌',
      f_resource: '编辑灯牌',
      f_type: 1
    },
    提交: {
      f_module: '编辑灯牌',
      f_resource: '提交',
      f_type: 4
    }
  }
};